module.exports = __webpack_public_path__ + "img/_ABS9785_mod.6564ef79.jpg";